import arrow from "../../../assetes/img/arrow.svg";
import arow2 from "../../../assetes/img/arow2.svg";
import QS from "../../../assetes/img/QS.svg";
export default function FaqSection() {
  return (
    <div className="text-white w-[500px] max-[600px]:w-[300px]  flex items-center justify-center m-auto flex-col mt-20">
      <span dir="rtl" className="font-black text-4xl max-[600px]:text-3xl z-10">
        سوالات متداول
      </span>
      <img
        className="absolute mt-[-1000px] max-[600px]:mt-[-1030px] max-[600px]:w-60 z-0"
        src={QS}
      />

      <div>
        <div className="text-right mt-20 ">
          <span
            dir="rtl"
            className="font-black text-[#7E42FF] text-xl p-5 max-[600px]:text-sm"
          >
            این دوره آنلاین برگزار میشه؟
          </span>
          <div className="absolute ml-[440px] max-[600px]:ml-[250px]">
            <img className="w-5" src={arrow} />
          </div>
          <div className="font-bold bg-[#2B2B2B] rounded-xl p-5  my-3 text-md max-[600px]:text-sm max-[600px]:font-normal">
            <span dir="rtl">
              بله ! دوره به صورت انلاین و لایو برگزار میشه پس هرجا که باشی
              میتونی راحت شرکت کنی
            </span>
          </div>
        </div>

        <div className="text-left mt-5 ">
          <span
            dir="rtl"
            className="font-black text-[#05AAF5] text-xl p-5 max-[600px]:text-sm"
          >
            چند جلسه اس ؟
          </span>
          <div className="absolute ml-[30px]">
            <img className="w-5" src={arow2} />
          </div>
          <div className="font-bold bg-[#2B2B2B] rounded-xl max-[600px]:text-sm p-5  my-3 text-md max-[600px]:font-normal">
            <span dir="rtl">
              دوره شامل 6 جلسه کاملا کاربردیه + تمرین و آموزش عملی
            </span>
          </div>
        </div>

        <div className="text-right mt-5 ">
          <span
            dir="rtl"
            className="font-black text-[#7E42FF] text-xl p-5 max-[600px]:text-sm"
          >
            پشتیبانی هم دارین؟
          </span>
          <div className="absolute ml-[440px] max-[600px]:ml-[250px]">
            <img className="w-5" src={arrow} />
          </div>
          <div className="font-bold bg-[#2B2B2B] rounded-xl max-[600px]:text-sm p-5  my-3 text-md max-[600px]:font-normal">
            <span dir="rtl">
              صددرصد کنارتیم! <br />
              تیم پشتیبانی حرفه‌ای ما از همون لحظه اول تا رسیدن به نتیجه‌،
              همراهته. همچنین لایوهای پرسش‌و‌پاسخ برای رفع اشکالاتت برگزار
              می‌کنیم تا هیچ سوالی بی‌جواب نمونه.
            </span>
          </div>
        </div>

        <div className="text-left mt-5 ">
          <span
            dir="rtl"
            className="font-black text-[#05AAF5] text-xl p-5 max-[600px]:text-sm"
          >
            مسئولیت حقوقی ساخت توکن با کیه ؟
          </span>
          <div className="absolute ml-[30px]">
            <img className="w-5" src={arow2} />
          </div>
          <div className="font-bold max-[600px]:font-normal  bg-[#2B2B2B] rounded-xl p-5 max-[600px]:text-sm my-3 text-md">
            <span dir="rtl">
              مسئولیت کامل توکن با خودتونه ! ما صرفا آموزش میدیم که چطور یه
              پروژه سالم و موفق بسازین نه اسکم کردن
            </span>
          </div>
        </div>

        <div className="text-right mt-5 ">
          <span
            dir="rtl"
            className="font-black text-[#7E42FF] text-xl p-5 max-[600px]:text-md max-[600px]:text-sm"
          >
            آیا ساخت توکن باعث دردسر حقوقی میشه؟
          </span>
          <div className="absolute ml-[440px] max-[600px]:ml-[250px]">
            <img className="w-5" src={arrow} />
          </div>
          <div className="font-bold bg-[#2B2B2B] rounded-xl p-5 max-[600px]:text-sm my-3 text-md max-[600px]:font-normal">
            <span dir="rtl">
              ما تو این دوره آموزش میدیم چجوری ماهیت حقوقی پروژه رو درک کنی و
              جلو اشتباهات پر ریسک رو بگیری. ولی اجرا و مسئولیت نهایی هر پروژه
              به عهده خودته
            </span>
          </div>
        </div>

        <div className="text-left mt-5 ">
          <span
            dir="rtl"
            className="font-black text-[#05AAF5] text-xl max-[600px]:text-md p-5 max-[600px]:text-sm"
          >
            هدف این دوره چیه؟
          </span>
          <div className="absolute ml-[30px]">
            <img className="w-5" src={arow2} />
          </div>
          <div className="font-bold bg-[#2B2B2B] rounded-xl p-5 max-[600px]:text-sm my-3 text-md max-[600px]:font-normal">
            <span dir="rtl">
              هدف ما اینه یادت بدیم چطور یه توکن واقعی قابل دفاع و پرسود بسازی و
              باهاش پول در بیاری _ بدون اینکه توی دام پروژه های مشکوک بیفتی
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
